__turbopack_context__.v({
  "badge": "MainVisual-module-scss-module__6806oW__badge",
  "badgeIcon": "MainVisual-module-scss-module__6806oW__badgeIcon",
  "dealTypeTab": "MainVisual-module-scss-module__6806oW__dealTypeTab",
  "dealTypeTabs": "MainVisual-module-scss-module__6806oW__dealTypeTabs",
  "desktopDealTypeContainer": "MainVisual-module-scss-module__6806oW__desktopDealTypeContainer",
  "highlightText": "MainVisual-module-scss-module__6806oW__highlightText",
  "innerContent": "MainVisual-module-scss-module__6806oW__innerContent",
  "leftCorner": "MainVisual-module-scss-module__6806oW__leftCorner",
  "mainVisual": "MainVisual-module-scss-module__6806oW__mainVisual",
  "mainVisualContent": "MainVisual-module-scss-module__6806oW__mainVisualContent",
  "mainVisualImage": "MainVisual-module-scss-module__6806oW__mainVisualImage",
  "mainVisualImageContainer": "MainVisual-module-scss-module__6806oW__mainVisualImageContainer",
  "mainVisualTitleText": "MainVisual-module-scss-module__6806oW__mainVisualTitleText",
  "mobileDealTypeContainer": "MainVisual-module-scss-module__6806oW__mobileDealTypeContainer",
  "rightCorner": "MainVisual-module-scss-module__6806oW__rightCorner",
  "tooltip": "MainVisual-module-scss-module__6806oW__tooltip",
  "tooltipArrow": "MainVisual-module-scss-module__6806oW__tooltipArrow",
  "tooltipContent": "MainVisual-module-scss-module__6806oW__tooltipContent",
  "wrap": "MainVisual-module-scss-module__6806oW__wrap",
});
